import { render, staticRenderFns } from "./showoffGamebets.vue?vue&type=template&id=24c4d0b5"
import script from "./showoffGamebets.vue?vue&type=script&lang=js"
export * from "./showoffGamebets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports